export default {
    name: "",
    key: "",
    module: "",
    type: "",
    sortOrder: 0,
    visible: true,
    protected: false,
    unique: false,
    group: "general",
    roles: {
        see: [],
        edit: []
    },
    relation: {
        foreign: "",
        key: [],
        type: ""
    },
    constraints: {
        required: false,
        default: "",
        display_condition: "",
        placeholder: "",
        length: {
            min: 1,
            max: 255,
        },
        date: {
            pattern: "",
            disable_past_dates: false,
            disable_future_dates: false,
            disabled_dates: {
                dates: [],
                to: "",
                from: "",
                days: [],
                days_of_month: [],
                ranges: []
            },
            highlighted_dates: {
                dates: [],
                to: "",
                from: "",
                days: [],
                days_of_month: [],
                ranges: [],
                include_disabled: false
            }
        },
        selectables: {
            items: [],
            multiple: false,
            range: {
                from: null,
                to: null
                }
        },
        table: {
            search: false,
            per_page: 10,
            fields: []
        },
        relation: {
            label: 'uuid'
        },
        custom_data: {},
        integrations: {}
    }
}